import { defineEntity, custom } from './_helpers.js';

export default defineEntity('disposalRun', {
    completed: custom({ scope: 'state' }),
    periodicDue: custom({ scope: 'state' }),
    recordsExpired: custom({ scope: 'state' }),
});
